import React from 'react'

export const BloxHistory = [
  {
    name: 'Histórico',
    component: React.lazy(() => import('../../modules/student/BloxHistory')),
    path: '/ecommerce-student/history',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
]
